import React from 'react';
export function HeroSection() {
  return <section className="relative w-full flex flex-col text-center px-4 py-8 sm:py-16 items-center justify-center pl-[20px] pr-[20px] pt-[20px] pb-[20px]" style={{
    background: 'linear-gradient(135deg, #0a0a0a 0%, #1a1000 30%, #0d0d00 60%, #0a0a0a 100%)'
  }} data-id="element-136">
      {/* Logo */}
      <div className="mb-4" data-id="element-137">
        <span className="text-[#FFD700] sm:text-2xl font-black tracking-widest text-[18px]" data-id="element-138">
          🎵 EDULABS
        </span>
      </div>

      {/* Main headline */}
      <h1 className="font-black text-white max-w-5xl sm:text-5xl md:text-7xl lg:text-8xl mb-[0px] text-[28px]" data-id="element-139">
        Todo tu año de Música
        <br data-id="element-140" />
        <span className="text-[#FFD700]" data-id="element-141">resuelto.</span>
      </h1>

      {/* Subtitle under H1 */}

      {/* Mockup image — LCP element, priority load with explicit dimensions */}
      <div className="w-full max-w-[240px] sm:max-w-[300px] md:max-w-sm mx-auto mb-4 mt-4" style={{
      aspectRatio: '1/1'
    }} data-id="element-142">
        <img src="https://cdn.magicpatterns.com/uploads/2rZ8SarQ4XHf2D3qwgWzUJ/Diseno-sin-titulo-_18_.webp" alt="PROFEPACK Megapack Música Lista - Combo Completo" className="w-full h-full object-contain" width={400} height={400} fetchPriority="high" data-id="element-143" />
      </div>

      {/* Subtitle */}
      <p className="text-[#FFD700] text-lg sm:text-2xl font-bold max-w-3xl mb-[0px]" data-id="element-144">
        "Listo para usar. Sin buscar más."
      </p>

      {/* Body */}
      <p className="text-white sm:text-lg max-w-2xl text-[16px] pt-[2px] pb-[2px] mb-[0px]" data-id="element-145">
        El sistema que usan miles de docentes de Música para planificar todo el
        año en una tarde — sin improvisar, sin buscar y sin perder fines de
        semana.
      </p>

      {/* Pills */}
      <div className="grid grid-cols-2 mb-[10px] gap-[4px] justify-items-center mt-3 max-w-md mx-auto" data-id="element-146">
        <span className="bg-black/50 border border-[#FFD700]/40 text-white text-[10px] sm:text-xs font-semibold px-2 py-1 rounded-full" data-id="element-147">
          📄 100% PDF
        </span>
        <span className="bg-black/50 border border-[#FFD700]/40 text-white text-[10px] sm:text-xs font-semibold px-2 py-1 rounded-full" data-id="element-148">
          ⚡ Acceso inmediato
        </span>
        <span className="bg-black/50 border border-[#FFD700]/40 text-white text-[10px] sm:text-xs font-semibold px-2 py-1 rounded-full" data-id="element-149">
          🌍 Todos los países hispanohablantes
        </span>
        <span className="bg-black/50 border border-[#FFD700]/40 text-white text-[10px] sm:text-xs font-semibold px-2 py-1 rounded-full" data-id="element-150">
          🎵 Primaria / Básica y Secundaria / Media
        </span>
      </div>

      {/* CTA Button */}
      <a href="#pricing" className="btn-gold-pulse bg-[#FFD700] text-black font-black text-base sm:text-2xl px-6 sm:px-10 py-4 sm:py-5 rounded-xl hover:bg-yellow-300 transition-colors inline-block mb-5 mt-4 w-full sm:w-auto max-w-sm" data-id="element-151">
        🎵 → QUIERO MI MEGAPACK AHORA
      </a>

      {/* Trust badges */}
      <p className="text-gray-300 text-xs sm:text-sm flex flex-wrap items-center justify-center gap-2 sm:gap-3" data-id="element-152">
        <span data-id="element-153">🛡️ Garantía 7 días sin preguntas</span>
        <span data-id="element-154">🔒 Pago 100% seguro</span>
        <span data-id="element-155">💳 Pagas en la moneda de tu país</span>
      </p>
    </section>;
}